'use client'


import ReCaptchaProvider from '@/components/home/contactForm/ReCaptchaProvider';
import RFQrequest from '@/components/contact/quoteRequest/RFQrequest';



export default function QuoteRequest(){

return (
  <ReCaptchaProvider>
    <RFQrequest/>
  </ReCaptchaProvider>
)
}